import { sendLeadFormHeapEvents } from 'client/javascript/form_analytics';
import { showElements, hideElements } from 'client/javascript/util/dom_utils';
import { setupPhoneInput } from 'client/javascript/phone';
import Form from 'client/javascript/lead_form';
import { submitLead } from 'client/javascript/submit_lead';

let form;
let iti;

const FORM_NODE_ID = 'nav-cta-lead-form';
const FORM_INIT_MESSAGE_ID = 'nav-cta-lead-initial';
const FORM_SUCCESS_MESSAGE_ID = 'nav-cta-lead-success';
const LEAD_SOURCE_DETAIL = 'Global Contact CTA';

const PRODUCT_INTERESTS_TO_LEAD_FORM_SUBTYPE = {
  WORKSPACE: 'Consultation - Other',
  MEMBERSHIP: 'Customer Support',
  OTHER: 'Other'
};

async function onSubmit(event, values) {
  const {
    email,
    phone,
    company_name: companyName,
    company_size: companySize,
    contact_name: contactName,
    product_interests: productInterest,
    marketing_consent: marketingConsent
  } = values;
  const leadSourceSubtype = PRODUCT_INTERESTS_TO_LEAD_FORM_SUBTYPE[productInterest];

  const interestParams = {
    product_interests: [productInterest]
  };

  if (productInterest === 'WORKSPACE') {
    interestParams.company_size = companySize;
  }

  const notes = `${values.notes || ''}
Interest: ${productInterest}
Company Size: ${companySize}`;

  await submitLead(
    {
      email,
      phone,
      company_name: companyName,
      contact_name: contactName,
      marketing_consent: marketingConsent,
      ...interestParams,
      notes,
      submission_type: 'lead',
      lead_source_subtype: leadSourceSubtype
    },
    LEAD_SOURCE_DETAIL
  );

  sendLeadFormHeapEvents(
    {
      email,
      phone,
      contact_name: contactName,
      company_size: companySize
    },
    LEAD_SOURCE_DETAIL
  );

  const initialMessage = document.getElementById(FORM_INIT_MESSAGE_ID);
  const successMessage = document.getElementById(FORM_SUCCESS_MESSAGE_ID);

  hideElements(form, initialMessage);
  showElements(successMessage);
}

export default function setUpContactUsForm() {
  form = document.getElementById(FORM_NODE_ID);

  if (!iti) {
    iti = setupPhoneInput(document.getElementById('nav-cta-phone'));
  }

  // eslint-disable-next-line no-new
  new Form(form, onSubmit);
}
